<div class="goreact-modal custom-params-dialog">
	<div class="goreact-modal-header">
		<h4 [id]="data.dialogTitleId" class="modal-title" translate="custom-params"></h4>
		<button
			type="button"
			class="close-btn"
			(click)="close()"
			[attr.aria-label]="'common_close' | translate">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<div class="custom-params-group">
			<span translate="custom-params_resource-link-id"></span>
			<div class="input-group">
				<input
					[ngModel]="data.resource_link_id"
					[attr.aria-label]="'custom-params_resource-link-id' | translate"
					readonly="readonly"/>
				<section [goCopyToClipboard]="data.resource_link_id" class="copy-clipboard">
					<button
						type="button"
						class="btn-none"
						[attr.aria-label]="'copy-value-to-clipboard' | translate: {
							'value': 'resouce link id'
						}">
						<i class="ficon-app-copy"></i>
					</button>
				</section>
			</div>
		</div>

		<div class="custom-params-group">
			<span translate="custom-params_context-id"></span>

			<div class="input-group">
				<input
					[ngModel]="data.context_id"
					[attr.aria-label]="'custom-params_context-id' | translate"
					readonly="readonly"/>
				<section [goCopyToClipboard]="data.context_id" class="copy-clipboard">
					<button
						type="button"
						class="btn-none"
						[attr.aria-label]="'copy-value-to-clipboard' | translate: {
							'value': 'context id'
						}">
						<i class="ficon-app-copy"></i>
					</button>
				</section>
			</div>
		</div>

		<div class="custom-params-group">
			<span translate="custom-params_user-id"></span>
			<div class="input-group">
				<input
					[ngModel]="data.user_id"
					[attr.aria-label]="'custom-params_user-id' | translate"
					readonly="readonly"/>

				<section [goCopyToClipboard]="data.user_id" class="copy-clipboard">
					<button
						type="button"
						class="btn-none"
						[attr.aria-label]="'copy-value-to-clipboard' | translate: {
							'value': 'user id'
						}">
						<i class="ficon-app-copy"></i>
					</button>
				</section>
			</div>
		</div>
	</div>
	<div class="goreact-modal-footer"></div>
</div>
